<template>
    <m-dialog maxHeight="50vh" :overlay="false" :show="show" :heading="title"
              @update:show="v => $emit('update:show', v)">
        <div v-if="chatStarted" class="w-full">
            <div class="flex">
                <div class="flex-1 bg-gray-100">
                    <div class="main-body container m-auto w-11/12 flex flex-col">
                        <div class="main flex-1 flex flex-col">
                            <div class="flex-1 flex">
                                <div class="chat-area flex-1 flex flex-col">
                                    <div class="messages flex-1 overflow-auto" ref="chatbox">
                                        <div v-for="message in messages" ref="message" v-intoview>
                                            <div v-if="message.userId === currentUserId" class="message mb-4 flex">
                                                <div class="flex-2">
                                                    <div class="w-12 h-12 relative">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                             viewBox="0 0 24 24"
                                                             stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                  d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"/>
                                                        </svg>
                                                        <span
                                                            class="absolute w-4 h-4 bg-gray-400 rounded-full right-0 bottom-0 border-2 border-white"></span>
                                                    </div>
                                                </div>
                                                <div class="flex-1 px-2">
                                                    <div
                                                        class="inline-block bg-gray-300 rounded-full p-2 px-6 text-gray-700">
                                                        <span>{{ message.message }}</span>
                                                    </div>
                                                    <div class="pl-4"><small class="text-gray-500">{{ message.user }} -
                                                        {{ message.time | datetime('%H:%i:%s') }}</small></div>
                                                </div>
                                            </div>
                                            <div v-else class="message me mb-4 flex text-right">
                                                <div class="flex-1 px-2">
                                                    <div
                                                        class="inline-block bg-blue-600 rounded-full p-2 px-6 text-white">
                                                        <span>{{ message.message }}</span>
                                                    </div>
                                                    <div class="pl-4"><small class="text-gray-500">{{ message.user }} -
                                                        {{ message.time | datetime('%H:%i:%s') }}</small></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="chatEnded" class="text-2xl bg-red-500 text-white">The chat has ended.</div>
        </div>
        <div v-else>
            <img class="m-auto" src="../../components/loader.gif" alt="loader"/>
            <div>If you do not want to wait, please click <i class="underline cursor-pointer"
                                                             @click="$emit('leaveMessage')">here</i> to leave us a
                message.
            </div>
        </div>

        <template v-slot:footer>
            <div v-if="chatStarted" class="flex-2 pt-4 pb-10">
                <div class="write bg-white shadow flex rounded-lg">
                    <div class="flex-1">
                                            <textarea @keydown.enter.prevent="sendMessage" v-model="message"
                                                      name="message"
                                                      class="w-full block outline-none py-4 px-4 bg-transparent"
                                                      rows="5" placeholder="Type a message..." autofocus></textarea>
                    </div>
                    <div class="flex-2 w-32 p-2 flex content-center items-center">
                        <div class="flex-1">
                            <button @click="sendMessage"
                                    class="bg-blue-400 w-20 h-10 rounded-full text-white inline-block">Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </m-dialog>
</template>

<script>
import Ajax from "@/js/ajax";
import "@/chat.js"

export default {
    props: ['id', 'show'],
    data() {
        return {
            message: '',
            currentUserId: window.initial.userId,
            messages: [],
            localId: this.id,
            chatStarted: false,
            title: 'Waiting for next available agent...',
            chatEnded: false
        }
    },
    mounted() {
        window.chatSignalStared.then(_ => {
            window.chatSignal.on('ReceiveMessage', (message) => {
                this.messages.push(message)
                this.chatStarted = true
            })
            window.chatSignal.on('ChatDetails', (data) => {
                this.title = data.title
            })
            window.chatSignal.on('EndChat', _ => {
                this.chatEnded = true
            })
        })
        if (this.localId) {
            this.startChat()
        } else {
            this.createChat()
        }
    },
    destroyed() {
        window.chatSignalStared.then(_ => {
            window.chatSignal.invoke('EndChat', parseInt(this.localId))
        })
    },
    methods: {
        createChat() {
            Ajax.post('/chat/create')
                .then(resp => {
                    this.localId = resp
                })
        },
        startChat() {
            window.chatSignalStared.then(_ => {
                window.chatSignal.invoke('StartChat', parseInt(this.localId), 'How can I help? / Hoe kan ek help?')
            })
        },
        sendMessage() {
            if (!this.message || this.chatEnded) return

            window.chatSignal.invoke('SendMessage', parseInt(this.localId), this.message)
                .then(_ => {
                    this.message = ''
                })
        }
    }
}
</script>